var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gallery-overlay" }, [
    _c("div", { staticClass: "gallery-overlay--outer-wrapper" }, [
      _c(
        "button",
        {
          staticClass:
            "gallery-overlay--btn btn btn__secondary btn__square btn__medium",
          on: { click: _vm.onClose }
        },
        [
          _c(
            "div",
            { staticClass: "swiper-gallery--btn-content btn--wrap" },
            [_c("ui-icon", { attrs: { symbol: "close", size: "medium" } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gallery-overlay--inner-wrapper" },
        [
          _c("swiper-gallery", {
            staticClass: "gallery-overlay--element",
            attrs: {
              "allow-overlay": false,
              "initial-idx": _vm.imageIdx,
              images: _vm.images
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fa6ec82", { render: render, staticRenderFns: staticRenderFns })
  }
}